import { render, staticRenderFns } from "./channelPreviewPdf.vue?vue&type=template&id=53e54b1a&scoped=true"
import script from "./channelPreviewPdf.vue?vue&type=script&lang=js"
export * from "./channelPreviewPdf.vue?vue&type=script&lang=js"
import style0 from "./channelPreviewPdf.vue?vue&type=style&index=0&id=53e54b1a&prod&lang=scss&scoped=true"
import style1 from "./channelPreviewPdf.vue?vue&type=style&index=1&id=53e54b1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e54b1a",
  null
  
)

export default component.exports